export const getGAEventTermsAccepted = (productId: string, level: string) => ({
    event: 'TermsAndConditions',
    eventPayload: {
        productId: `${productId}_${level}`,
    },
    isContractRenewal: true,
});
